import { getAxiosInstance } from "../../../np-rest/rest";
import { snackActions } from '../../../sc-utilities/SnackBar';

export const importData = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {

            let res = await rest.post('import-export/import-data-from-old-securaze', data);
            if (res.status === 200) {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : 'Import data successful '}`,
                    options: {
                        variant: 'success'
                    }
                });
                return;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Download failed '}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}

